import _classCallCheck from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/inherits.js";
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module horizontal-line/horizontallinecommand
 */

import Command from '@ckeditor/ckeditor5-core/src/command';
import { findOptimalInsertionPosition } from '@ckeditor/ckeditor5-widget/src/utils';

/**
 * The horizontal line command.
 *
 * The command is registered by {@link module:horizontal-line/horizontallineediting~HorizontalLineEditing} as `'horizontalLine'`.
 *
 * To insert a horizontal line at the current selection, execute the command:
 *
 *		editor.execute( 'horizontalLine' );
 *
 * @extends module:core/command~Command
 */
var HorizontalLineCommand = /*#__PURE__*/function (_Command) {
  function HorizontalLineCommand() {
    _classCallCheck(this, HorizontalLineCommand);
    return _callSuper(this, HorizontalLineCommand, arguments);
  }
  _inherits(HorizontalLineCommand, _Command);
  return _createClass(HorizontalLineCommand, [{
    key: "refresh",
    value:
    /**
     * @inheritDoc
     */
    function refresh() {
      this.isEnabled = isHorizontalLineAllowed(this.editor.model);
    }

    /**
     * Executes the command.
     *
     * @fires execute
     */
  }, {
    key: "execute",
    value: function execute() {
      var model = this.editor.model;
      model.change(function (writer) {
        var horizontalElement = writer.createElement('horizontalLine');
        model.insertContent(horizontalElement);
        var nextElement = horizontalElement.nextSibling;

        // Check whether an element next to the inserted horizontal line is defined and can contain a text.
        var canSetSelection = nextElement && model.schema.checkChild(nextElement, '$text');

        // If the element is missing, but a paragraph could be inserted next to the horizontal line, let's add it.
        if (!canSetSelection && model.schema.checkChild(horizontalElement.parent, 'paragraph')) {
          nextElement = writer.createElement('paragraph');
          writer.insert(nextElement, writer.createPositionAfter(horizontalElement));
        }

        // Put the selection inside the element, at the beginning.
        if (nextElement) {
          writer.setSelection(nextElement, 0);
        }
      });
    }
  }]);
}(Command); // Checks if the `horizontalLine` element can be inserted at the current model selection.
//
// @param {module:engine/model/model~Model} model
// @returns {Boolean}
export { HorizontalLineCommand as default };
function isHorizontalLineAllowed(model) {
  var schema = model.schema;
  var selection = model.document.selection;
  return isHorizontalLineAllowedInParent(selection, schema, model) && !checkSelectionOnObject(selection, schema);
}

// Checks if a horizontal line is allowed by the schema in the optimal insertion parent.
//
// @param {module:engine/model/selection~Selection|module:engine/model/documentselection~DocumentSelection} selection
// @param {module:engine/model/schema~Schema} schema
// @param {module:engine/model/model~Model} model Model instance.
// @returns {Boolean}
function isHorizontalLineAllowedInParent(selection, schema, model) {
  var parent = getInsertHorizontalLineParent(selection, model);
  return schema.checkChild(parent, 'horizontalLine');
}

// Checks if the selection is on object.
//
// @param {module:engine/model/selection~Selection|module:engine/model/documentselection~DocumentSelection} selection
// @param {module:engine/model/schema~Schema} schema
// @returns {Boolean}
function checkSelectionOnObject(selection, schema) {
  var selectedElement = selection.getSelectedElement();
  return selectedElement && schema.isObject(selectedElement);
}

// Returns a node that will be used to insert a horizontal line with `model.insertContent` to check if the horizontal line can be
// placed there.
//
// @param {module:engine/model/selection~Selection|module:engine/model/documentselection~DocumentSelection} selection
// @param {module:engine/model/model~Model} model Model instance.
// @returns {module:engine/model/element~Element}
function getInsertHorizontalLineParent(selection, model) {
  var insertAt = findOptimalInsertionPosition(selection, model);
  var parent = insertAt.parent;
  if (parent.isEmpty && !parent.is('$root')) {
    return parent.parent;
  }
  return parent;
}